import type { ReactNode } from "react";
import { Sun, CheckSquare, CalendarIcon, BarChart3, SparklesIcon } from "../../../ui/icons";

export type ValidationType = "task-status" | "task-created" | "event-created";

export interface TutorialStep {
  readonly icon: ReactNode;
  readonly title: string;
  readonly instruction: string;
  readonly action?: string;
  readonly target?: string;
  readonly mode: "modal" | "guided";
  readonly validate?: ValidationType;
}

export const STEPS: readonly TutorialStep[] = [
  {
    icon: <SparklesIcon className="w-10 h-10" />,
    title: "Bienvenue sur Palnia !",
    instruction:
      "Nous allons apprendre à utiliser l'application étape par étape, avec des données fictives qui seront supprimées à la fin.",
    mode: "modal",
  },
  {
    icon: <Sun className="w-10 h-10" />,
    title: "Changez le statut d'une tâche",
    instruction:
      "Des tâches fictives sont apparues. Chacune a un bouton de statut : « A faire » en gris, « En cours » en orange, « Fait » en vert.",
    action: "Cliquez sur le bouton « A faire » d'une tâche pour changer son statut.",
    target: "task-card",
    mode: "guided",
    validate: "task-status",
  },
  {
    icon: <CheckSquare className="w-10 h-10" />,
    title: "Créez votre première tâche",
    instruction:
      "Le champ « Ajouter une tâche... » en haut de la liste permet de créer rapidement une tâche. Choisissez une catégorie et une date si besoin.",
    action: "Tapez un titre puis appuyez sur Entrée ou le bouton +.",
    target: "quick-add",
    mode: "guided",
    validate: "task-created",
  },
  {
    icon: <CalendarIcon className="w-10 h-10" />,
    title: "Ajoutez un événement au calendrier",
    instruction:
      "Les blocs colorés sont vos événements, organisés par catégorie. Vous pouvez les déplacer et les redimensionner.",
    action: "Cliquez sur un créneau horaire vide pour créer un événement.",
    mode: "guided",
    validate: "event-created",
  },
  {
    icon: <BarChart3 className="w-10 h-10" />,
    title: "Vos statistiques",
    instruction:
      "Retrouvez ici vos métriques de productivité : tâches actives, taux de complétion, jours d'activité consécutifs et répartition par catégorie.",
    mode: "guided",
  },
  {
    icon: <SparklesIcon className="w-10 h-10" />,
    title: "C'est parti !",
    instruction:
      "Vous maîtrisez les bases ! Naviguez via la barre en bas : Aujourd'hui, Calendrier, Tâches, Habitudes. Personnalisez l'app via les paramètres.",
    action: "Paramètres → Outils → Revoir le tutoriel",
    mode: "modal",
  },
];
